// extracted by mini-css-extract-plugin
module.exports = {"name":"PopularProductsOverview_name__Ppy5i"};